import React from 'react';
import {
  Box,
  Container,
  Typography,
  Tabs,
  Tab,
  Grid,
  Avatar,
  Stack,
  Paper
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const categories = [
  '전체', '교양', '예능', '시사', '경제', '비즈니스', '일상/토크', '여행', '도서', '대중문화', '스포츠/레저', '방송사', '종교'
];

const tabProps = (index: number) => {
  return {
    id: `category-tab-${index}`,
    'aria-controls': `tabpanel-${index}`,
  };
};


////////////////////////////////////////////////////
// post 데이터 샘플
const posts = [
    {rank: 1, title: '부모의 역할이 바꾸는 아이의 공부 습관 – 초중고 학습을 위한 실천 전략', channel: 'ch1', description: '부모의 역할이 바꾸는 아이의 공부 습관 – 초중고 학습을 위한 실천 전략', thumbnail: 'https://via.placeholder.com/80x80?text=1', rankChange: 1}, 
    {rank: 2, title: '초등학생 공부 습관, 이렇게 기르세요!', channel: 'ch2', description: '초등학생 공부 습관, 이렇게 기르세요!', thumbnail: 'https://via.placeholder.com/80x80?text=2', rankChange: -1}, 
    {rank: 3, title: '성적 올리는 중학생 공부법 BEST 5 – 부모가 꼭 알아야 할 실전 팁!', channel: 'ch3', description: '성적 올리는 중학생 공부법 BEST 5 – 부모가 꼭 알아야 할 실전 팁!', thumbnail: 'https://via.placeholder.com/80x80?text=3', rankChange: 0}, 
    {rank: 4, title: '고등학생 자기주도학습 비결 🔥 성공하는 공부 습관 만들기 전략', channel: 'ch4', description: '고등학생 자기주도학습 비결 🔥 성공하는 공부 습관 만들기 전략', thumbnail: 'https://via.placeholder.com/80x80?text=4', rankChange: 2}, 
    {rank: 5, title: '자기주도학습이 성공을 결정짓는 이유! 우리 아이 공부법의 핵심 전략', channel: 'ch5', description: '자기주도학습이 성공을 결정짓는 이유! 우리 아이 공부법의 핵심 전략', thumbnail: 'https://via.placeholder.com/80x80?text=5', rankChange: -2}, 
    {rank: 6, title: '아이 집중력 키우는 부모의 전략, 이렇게 실천해보세요!', channel: 'ch6', description: '아이 집중력 키우는 부모의 전략, 이렇게 실천해보세요!', thumbnail: 'https://via.placeholder.com/80x80?text=6', rankChange: 0}, 
    {rank: 7, title: '공부 잘하는 아이들, 이렇게 다릅니다! 부모가 알아야 할 7가지 특징', channel: 'ch7', description: '공부 잘하는 아이들, 이렇게 다릅니다! 부모가 알아야 할 7가지 특징', thumbnail: 'https://via.placeholder.com/80x80?text=7', rankChange: 1}, 
    {rank: 8, title: '뇌과학이 밝힌 초집중 학습법: 기억력과 이해력을 높이는 뇌 활용 전략', channel: 'ch8', description: '뇌과학이 밝힌 초집중 학습법: 기억력과 이해력을 높이는 뇌 활용 전략', thumbnail: 'https://via.placeholder.com/80x80?text=8', rankChange: -1}, 
    {rank: 9, title: '아침 공부가 성적을 바꾼다? 과학적 근거와 실천 전략',  channel: 'ch9', description: '아침 공부가 성적을 바꾼다? 과학적 근거와 실천 전략', thumbnail: 'https://via.placeholder.com/80x80?text=9', rankChange: 0},     
    {rank: 10, title: '공부 시간 관리의 기술, 성적 향상의 첫걸음!', channel: 'ch10', description: '공부 시간 관리의 기술, 성적 향상의 첫걸음!', thumbnail: 'https://via.placeholder.com/80x80?text=10', rankChange: 1}, 
    {rank: 11, title: '하루를 바꾸는 공부 계획 세우기 전략', channel: 'ch11', description: '하루를 바꾸는 공부 계획 세우기 전략', thumbnail: 'https://via.placeholder.com/80x80?text=11', rankChange: 0},
    {rank: 12, title: '공부 안 하는 아이, 부모는 어떻게 도와줘야 할까?', channel: 'ch12', description: '공부 안 하는 아이, 부모는 어떻게 도와줘야 할까?', thumbnail: 'https://via.placeholder.com/80x80?text=12', rankChange: 0},
    {rank: 13, title: '공부를 싫어하는 아이, 부모가 꼭 알아야 할 해결법', channel: 'ch13', description: '공부를 싫어하는 아이, 부모가 꼭 알아야 할 해결법', thumbnail: 'https://via.placeholder.com/80x80?text=13', rankChange: 0},
    {rank: 14, title: '스마트폰 중독 아이, 공부 습관 이렇게 바로잡자!', channel: 'ch14', description: '스마트폰 중독 아이, 공부 습관 이렇게 바로잡자!', thumbnail: 'https://via.placeholder.com/80x80?text=14', rankChange: 0},
    {rank: 15, title: '게임 중독 아이, 학습에 어떻게 유도할까?', channel: 'ch15', description: '게임 중독 아이, 학습에 어떻게 유도할까?', thumbnail: 'https://via.placeholder.com/80x80?text=15', rankChange: 0},
    {rank: 16, title: '아이의 공부 스트레스, 이렇게 풀어보세요!', channel: 'ch16', description: '아이의 공부 스트레스, 이렇게 풀어보세요!', thumbnail: 'https://via.placeholder.com/80x80?text=16', rankChange: 0},
    {rank: 17, title: '고교학점제 시리즈 ① 고교학점제란? 개념과 도입 배경 총정리', channel: 'ch17', description: '고교학점제 시리즈 ① 고교학점제란? 개념과 도입 배경 총정리', thumbnail: 'https://via.placeholder.com/80x80?text=17', rankChange: 0},
    ];
////////////////////////////////////////////////////


///////////////////////////////////////////
const samplePodcasts = Array.from({ length: 15 }).map((_, i) => ({
  rank: i + 1,
  title: `팟캐스트 제목 ${i + 1}`,
  channel: `채널 ${i + 1}`,
  description: `여기는 설명 텍스트입니다. ${i + 1}`,
  thumbnail: `https://via.placeholder.com/80x80?text=${i + 1}`,
  rankChange: i % 3 === 0 ? 1 : i % 3 === 1 ? -1 : 0
}));

const Post = () => {
  const [selectedTab, setSelectedTab] = React.useState(0);
  const navigate = useNavigate();

  return (
    <Container sx={{ mt: 3 }}>
      {/* 상단 제목 */}
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Posts
      </Typography>

      {/* 카테고리 탭 */}
      {/* <Tabs
        value={selectedTab}
        onChange={(e, newValue) => setSelectedTab(newValue)}
        variant="scrollable"
        scrollButtons
        allowScrollButtonsMobile
        sx={{ borderBottom: '1px solid #ddd' }}
      >
        {categories.map((cat, idx) => (
          <Tab key={cat} label={cat} {...tabProps(idx)} sx={{ fontWeight: selectedTab === idx ? 'bold' : 400 }} />
        ))}
      </Tabs> */}

      {/* 콘텐츠 영역 */}
      <Grid container spacing={2} mt={2} marginBottom={12}>
        {posts.map(post => (
            <Grid item xs={12} md={6} key={post.rank}>
            <Paper
                sx={{
                p: 2,
                display: 'flex',
                alignItems: 'flex-start',
                gap: 2,
                height: 120, // ✅ 고정된 전체 카드 높이
                overflow: 'hidden',
                cursor: 'pointer',
                }}
                onClick={() => navigate(`/posts/${post.rank}`)}
            >
                <Typography
                variant="h5"
                fontWeight="bold"
                sx={{ minWidth: 32, textAlign: 'center', mt: 1 }}
                >
                {post.rank}
                </Typography>

                <Avatar
                src={post.thumbnail}
                variant="rounded"
                sx={{ width: 64, height: 64, flexShrink: 0 }}
                />

                <Box
                sx={{
                    flexGrow: 1,
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    height: '100%',
                }}
                >
                <Typography
                    fontWeight="bold"
                    sx={{
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 2, // ✅ 제목 두 줄 제한
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    fontSize: '1rem',
                    lineHeight: '1.4',
                    }}
                >
                    {post.title}
                </Typography>

                <Typography variant="body2" color="text.secondary">
                    {post.channel}
                </Typography>

                <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 2, // ✅ 설명 두 줄 제한
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    fontSize: '0.875rem',
                    lineHeight: '1.4',
                    }}
                >
                    {post.description}
                </Typography>
                </Box>

                {/* <Typography
                variant="body2"
                color={
                    post.rankChange > 0
                    ? 'green'
                    : post.rankChange < 0
                    ? 'red'
                    : 'gray'
                }
                fontWeight="bold"
                sx={{ whiteSpace: 'nowrap', mt: 1 }}
                >
                {post.rankChange > 0
                    ? `▲ ${post.rankChange}`
                    : post.rankChange < 0
                    ? `▼ ${Math.abs(post.rankChange)}`
                    : '-'}
                </Typography> */}
            </Paper>
            </Grid>
        ))}
        </Grid>


    </Container>
  );
};

export default Post;
